import 'react-app-polyfill/stable';
import 'core-js';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import store from './store';

// Dev-only: suppress noisy ResizeObserver errors that can trigger CRA overlay
// and make the page feel "stuck", even though the app keeps running.
if (process.env.NODE_ENV === 'development') {
  const resizeObserverRegex =
    /ResizeObserver loop (limit exceeded|completed with undelivered notifications)/;

  window.addEventListener('error', event => {
    if (resizeObserverRegex.test(event?.message || '')) {
      event.stopImmediatePropagation();
    }
  });
}

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
